<template>
  <div>
    <ativar-ou-inativar-associacao-dialog
      :is-ativar-ou-inativar-associacao-dialog-open.sync="isAtivarOuInativarAssociacaoFilaTipoSolicitacaoDialogOpen"
      :is-associacao-ativa-mensagem="isAssociacaoAtivaMensagem"
      :loading="loading"
      :close-dialog="closeAssociarOuDesassociar"
      :confirmar-ativacao-ou-inativacao-da-associacao="confirmarAtivacaoOuInativacaoDaAssociacao"
    />

    <configurar-associacao-fila-tipo-solicitacao-dialog
      :is-configurar-associacao-fila-tipo-solicitacao-dialog-open.sync="openEditFormulario"
      :associacao-data="associacaoSelecionada"
      :tipo-solicitacao-id="tipoSolicitacaoId"
      @refetch-data="$emit('refetch-data')"
    />

    <v-data-table
      :headers="headers"
      :items="items"
      :acesso-disable="acessoDisable"
      hide-default-footer
      :item-class="cursorPointer"
      @click:row="openEditAssociacaoFilaTipoSolicitacao"
    >
      <template #[`item.nome`]="{ item }">
        <div class="d-flex align-center">
          <v-avatar
            :color="`${$vuetify.theme.dark ? 'primary' : '#DCDCDC'}`"
            size="32"
          >
            <span :class="`${$vuetify.theme.dark ? 'white--text' : 'primary--text'} font-weight-bold`">
              {{ item.filaNome.toUpperCase().charAt(0) }}
            </span>
          </v-avatar>
          <div class="d-flex flex-column ms-3 text-capitalize">
            {{ item.filaNome }}
          </div>
        </div>
      </template>

      <template #[`item.descricao`]="{ item }">
        <span class="text-capitalize">
          {{ item.filaDescricao }}
        </span>
      </template>

      <template #[`item.ativo`]="{ item }">
        <v-chip
          class="v-chip-light-bg font-weight-semibold text-capitalize"
          small
          :class="`${item.ativo ? 'success--text' : 'secondary--text'}`"
          :color="`${item.ativo ? 'success' : 'secondary'}`"
        >
          {{ item.ativo ? "Ativa" : "Inativa" }}
        </v-chip>
      </template>

      <template #[`item.actions`]="{ item }">
        <v-menu
          left
          bottom
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              class="ml-n5"
              color="primary"
              v-on="on"
            >
              <v-icon @click="ativarOuInativarAssociacaoItem(item)">
                {{ icons.mdiDotsVertical }}
              </v-icon>
            </v-btn>
          </template>

          <v-list v-if="acessoDisable">
            <v-list-item>
              <v-list-item-title
                role="button"
                class="d-flex align-end"
                @click="openAssociarOuDesassociar"
              >
                <v-icon
                  size="20"
                  class="mr-1"
                >
                  {{ isAssociacaoAtiva ? icons.mdiCloseThick : icons.mdiCheckBold }}
                </v-icon>
                <span class="text-capitalize"> {{ isAssociacaoAtivaMensagem }} </span>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import { mdiCheckBold, mdiCloseThick, mdiDotsVertical } from '@mdi/js'
import AtivarOuInativarAssociacaoDialog from '@/views/ativar-ou-inativar-associacao-dialog/AtivarOuInativarAssociacaoDialog.vue'
import ConfigurarAssociacaoFilaTipoSolicitacaoDialog from '@/views/fila/tab-tipo-solicitacao/ConfigurarAssociacaoFilaTipoSolicitacaoDialog.vue'
import TipoSolicitacaoService from '@/services/modules/TipoSolicitacaoService'

export default {
  components: {
    AtivarOuInativarAssociacaoDialog,
    ConfigurarAssociacaoFilaTipoSolicitacaoDialog,
  },

  props: {
    items: {
      type: Array,
      default: () => [],
    },
    acessoDisable: {
      type: Boolean,
      default: true,
    },
    tipoSolicitacaoId: {
      type: Number,
      required: true,
    },
  },

  setup(props, { emit }) {
    const isAtivarOuInativarAssociacaoFilaTipoSolicitacaoDialogOpen = ref(false)
    const openEditFormulario = ref(false)
    const associacaoSelecionada = ref({})

    const loading = ref(false)
    const filaId = ref(0)
    const isAssociacaoAtiva = ref(undefined)
    const isAssociacaoAtivaMensagem = ref('')

    function ativarOuInativarAssociacaoItem(item) {
      filaId.value = Number(item.filaId)
      isAssociacaoAtiva.value = item.ativo
      isAssociacaoAtivaMensagem.value = item.ativo ? 'inativar' : 'ativar'
    }

    function openEditAssociacaoFilaTipoSolicitacao(item) {
      openEditFormulario.value = true
      associacaoSelecionada.value = item
    }

    const openAssociarOuDesassociar = () => {
      isAtivarOuInativarAssociacaoFilaTipoSolicitacaoDialogOpen.value = true
    }
    const closeAssociarOuDesassociar = () => {
      isAtivarOuInativarAssociacaoFilaTipoSolicitacaoDialogOpen.value = false
    }
    async function confirmarAtivacaoOuInativacaoDaAssociacao() {
      try {
        loading.value = true
        await TipoSolicitacaoService.ativarOuInativarTipoSolicitacaoFila(
          props.tipoSolicitacaoId,
          filaId.value,
          { ativar: !isAssociacaoAtiva.value },
        )
        emit('refetch-data')
      } finally {
        closeAssociarOuDesassociar()
        loading.value = false
      }
    }

    const headers = [
      { text: 'NOME', value: 'nome' },
      { text: 'DESCRICAO', value: 'descricao' },
      { text: 'STATUS', value: 'ativo' },
      {
        text: 'OPÇÔES',
        value: 'actions',
        align: 'center',
      },
    ]

    return {
      isAtivarOuInativarAssociacaoFilaTipoSolicitacaoDialogOpen,
      openEditFormulario,
      associacaoSelecionada,

      loading,
      isAssociacaoAtiva,
      isAssociacaoAtivaMensagem,
      openEditAssociacaoFilaTipoSolicitacao,
      ativarOuInativarAssociacaoItem,
      openAssociarOuDesassociar,
      closeAssociarOuDesassociar,
      confirmarAtivacaoOuInativacaoDaAssociacao,
      headers,

      icons: {
        mdiCheckBold,
        mdiCloseThick,
        mdiDotsVertical,
      },
      cursorPointer: item => (item.ativo || item.ativo === null ? 'cursor-pointer' : ''),
    }
  },
}
</script>
